"use client";

import ResponsiveHeader from "@/components/ResponsiveHeader";
import { useLanguage } from "@/contexts/LanguageContext";
import { getHomeStrings } from "@/i18n/homepagedict";

export default function LegalHeader() {
  const { locale } = useLanguage();
  const t = getHomeStrings(locale);

  // Intentionally empty navLinks to remove landing anchors (How it works, Features, Reviews, Pricings)
  const navLinks = [];

  return (
    <ResponsiveHeader
      navLinks={navLinks}
      loginLabel={t.nav_login}
      signupLabel={t.nav_signup}
    />
  );
}
